import React from 'react';
import { FaAward } from 'react-icons/fa';
import { CompanyName } from '../../utils/Constants';
// Replace this path with your actual logo asset when available
import FemdomAwardsLogo from '../../assets/images/logos/awards-logo.webp';

const AWARD_URL = 'https://femdom-awards.com/';

function VoteForMeNowCta() {
  return (
    <section
      className='grid px-6 lg:px-0'
      aria-labelledby='vote-now-title'
    >
      <div className='grid neon-border rounded overflow-hidden'>
        <div className='grid gap-4 bg-colour3/10 p-6 rounded'>
          {/* Header */}
          <header className='grid gap-2 text-center'>
            <h3
              id='vote-now-title'
              className='font-titleFont neon_text_heavy_redpink text-2xl md:text-3xl tracking-wider drop-shadow-lg'
            >
              VOTE FOR ME NOW
            </h3>
            <p className='text-white/90 text-base md:text-lg leading-relaxed'>
              Go to the site below and choose the dropdown for
              <strong> “Best Session Domme.”</strong> Cast your vote for{' '}
              <strong>{CompanyName}</strong>.
            </p>
          </header>

          {/* Logo + Link */}
          <div className='grid gap-4 justify-items-center'>
            <a
              href={AWARD_URL}
              target='_blank'
              rel='noopener noreferrer'
              className='grid place-items-center gap-3 px-5 py-4 rounded-2xl bg-black border-2 border-colour1 hover:bg-colour5/50 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-colour6'
              aria-label='Open Femdom Awards website in a new tab'
              title='Femdom Awards'
            >
              {/* Award Icon in same style as other icons */}
              <FaAward className='text-colour7 text-3xl' aria-hidden='true' />
              <img
                src={FemdomAwardsLogo}
                alt='Femdom Awards Logo'
                className='w-44 h-auto'
                width='176'
                height='64'
                loading='lazy'
                decoding='async'
              />
              <span className='text-colour1 font-extrabold'>
                femdom-awards.com
              </span>
            </a>

            {/* Short step-by-step helper text */}
            <ol className='grid gap-1 text-sm text-white/80 text-center'>
              <li>1. Open the site.</li>
              <li>2. Find the category dropdown.</li>
              <li>
                3. Select <em>Best Session Domme</em>.
              </li>
              <li>
                4. Vote for <strong>{CompanyName}</strong>.
              </li>
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}

export default VoteForMeNowCta;
